module.exports = __webpack_public_path__ + "img/មាន់ជល់.80cfd76f.png";